import { Button, Input } from "@mui/joy";
import React, {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";

type MatricsProps = {
  id: number;
  matrice_name: string;
  backend_matrice_name: string;
};
type Condition = {
  metric: string;
  metric_error?: boolean;
  parameter: string;
  parameter_error?: boolean;
  Operation: string;
  Operation_error?: boolean;
  initial_value: string;
  initial_value_error?: boolean;
  dependent_value: string;
  dependent_value_error?: boolean;
};
type ParametersProps = {
  id: number;
  parameter: string;
};
type OperationProps = {
  id: number;
  operation: string;
};
type LocalConditionProps = {
  index: number;
  cond: Condition;
  matricsArr: MatricsProps[];
  parameterArr: ParametersProps[];
  operationsArr: OperationProps[];
  localConditionsLength: number;
  newconditionsArr: Condition[];
  setLocalConditions: Dispatch<SetStateAction<Condition[]>>;
};
const CondCmpForCreate: React.FC<LocalConditionProps> = ({
  cond,
  index,
  matricsArr,
  parameterArr,
  operationsArr,
  localConditionsLength,
  newconditionsArr,
  setLocalConditions,
}) => {
  const [parametersToggle, setParametersToggle] = useState<boolean>(false);
  const [matricsToggle, setMatricsToggle] = useState<boolean>(false);
  const [operationsToggle, setOperationsToggle] = useState<boolean>(false);

  let parameterRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let parameterBtnRef = useRef<HTMLButtonElement | null>(null); // Menu button reference

  let metriceRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let metriceBtnRef = useRef<HTMLButtonElement | null>(null); // Menu button reference

  let operationRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let operationBtnRef = useRef<HTMLButtonElement | null>(null); // Menu button reference

  const parameterClickOutsideHandler = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (parameterRef)
    if (
      parameterRef.current &&
      !parameterRef.current.contains(event.target as Node) &&
      parameterBtnRef.current &&
      !parameterBtnRef.current.contains(event.target as Node)
    ) {
      setParametersToggle(false); // Close the dropdown if clicked outside
    }
  };

  const metriceClickOutsideHandler = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (parameterRef)
    if (
      metriceRef.current &&
      !metriceRef.current.contains(event.target as Node) &&
      metriceBtnRef.current &&
      !metriceBtnRef.current.contains(event.target as Node)
    ) {
      setMatricsToggle(false); // Close the dropdown if clicked outside
    }
  };

  const operationClickOutsideHandler = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (parameterRef)
    if (
      operationRef.current &&
      !operationRef.current.contains(event.target as Node) &&
      operationBtnRef.current &&
      !operationBtnRef.current.contains(event.target as Node)
    ) {
      setOperationsToggle(false); // Close the dropdown if clicked outside
    }
  };

  // Add event listener to detect clicks outside
  useEffect(() => {
    // Attach the click event listener to the document
    document.addEventListener("click", parameterClickOutsideHandler);
    document.addEventListener("click", metriceClickOutsideHandler);
    document.addEventListener("click", operationClickOutsideHandler);
    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", parameterClickOutsideHandler);
      document.removeEventListener("click", metriceClickOutsideHandler);
      document.addEventListener("click", operationClickOutsideHandler);
    };
  }, []);

  return (
    <div
      className="w-full flex flex-col p-4 items-center gap-4 rounded-2"
      style={{
        backgroundColor: "#F9F9FB",
      }}
    >
      <div className="w-full flex justify-between items-center gap-4 self-stretch">
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            fontFamily: "Inter",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "18px",
          }}
        >
          Condition {`${index + localConditionsLength + 1}`}
        </div>
        <div
          className="flex w-[20px] h-[20px] px-[2.5px] py-[1.67px] justify-center items-center cursor-pointer"
          onClick={(event) => {
            event.stopPropagation();
            if(localConditionsLength === 0 && newconditionsArr?.length === 1){
              return;
            } else {
              setLocalConditions((prev) => prev.filter((_, i) => i !== index));
            }
          }}
        >
          {localConditionsLength > 0 ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
            >
              <path
                d="M15.25 4.58301L14.7336 12.9373C14.6016 15.0717 14.5356 16.1389 14.0006 16.9062C13.7361 17.2856 13.3955 17.6057 13.0006 17.8464C12.2018 18.333 11.1325 18.333 8.99395 18.333C6.8526 18.333 5.78192 18.333 4.98254 17.8455C4.58733 17.6044 4.24666 17.2837 3.98224 16.9037C3.4474 16.1352 3.38288 15.0664 3.25384 12.929L2.75 4.58301"
                stroke="#D10C00"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M1.5 4.58317H16.5M12.3798 4.58317L11.8109 3.40961C11.433 2.63005 11.244 2.24027 10.9181 1.99718C10.8458 1.94325 10.7692 1.89529 10.6892 1.85375C10.3283 1.6665 9.8951 1.6665 9.02877 1.6665C8.14069 1.6665 7.69665 1.6665 7.32974 1.8616C7.24842 1.90484 7.17082 1.95475 7.09774 2.01081C6.76803 2.26375 6.58386 2.6678 6.2155 3.47589L5.71077 4.58317"
                stroke="#D10C00"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M6.91699 13.75L6.91699 8.75"
                stroke="#D10C00"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M11.083 13.75L11.083 8.75"
                stroke="#D10C00"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
            >
              <path
                d="M15.25 4.5835L14.7336 12.9377C14.6016 15.0722 14.5356 16.1394 14.0006 16.9067C13.7361 17.2861 13.3955 17.6062 13.0006 17.8468C12.2018 18.3335 11.1325 18.3335 8.99395 18.3335C6.8526 18.3335 5.78192 18.3335 4.98254 17.8459C4.58733 17.6049 4.24666 17.2842 3.98224 16.9042C3.4474 16.1357 3.38288 15.0669 3.25384 12.9295L2.75 4.5835"
                stroke="#B7B7B9"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M1.5 4.58341H16.5M12.3798 4.58341L11.8109 3.40985C11.433 2.6303 11.244 2.24052 10.9181 1.99742C10.8458 1.9435 10.7692 1.89553 10.6892 1.854C10.3283 1.66675 9.8951 1.66675 9.02877 1.66675C8.14069 1.66675 7.69665 1.66675 7.32974 1.86185C7.24842 1.90509 7.17082 1.95499 7.09774 2.01105C6.76803 2.264 6.58386 2.66804 6.2155 3.47613L5.71077 4.58341"
                stroke="#B7B7B9"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M6.91699 13.75L6.91699 8.75"
                stroke="#B7B7B9"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M11.083 13.75L11.083 8.75"
                stroke="#B7B7B9"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          )}
        </div>
      </div>

      <div className="flex w-full flex-col items-start gap-3">
        <div className="w-full gap-4 flex items-start">
          <div className="flex w-[33%] flex-col items-start gap-2 ">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              Matrices
            </div>
            <div className="relative w-full">
              <Button
                ref={metriceBtnRef}
                // color="neutral"
                sx={{
                  border: `1px solid #EAEAED`,
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  height: "38px",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "#FFF",
                  width: "100%",
                  ":hover": {
                    backgroundColor: "#FFF",
                  },
                }}
                onClick={() => setMatricsToggle(!matricsToggle)}
              >
                <div
                  className=""
                  style={{
                    color: cond?.metric ? "#1C1C1E" : "#97979A",
                    fontSize: "12px",
                    fontWeight: cond?.metric ? "500" : "400",
                    lineHeight: "18px",
                  }}
                >
                  {cond?.metric ? matricsArr.find(m => m?.backend_matrice_name === cond?.metric)?.matrice_name : "Select Matrices"}
                </div>
                {matricsToggle ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                      fill="#1C1C1E"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.56234 12.0625L6.5415 9.04168C6.49984 9.00001 6.46859 8.95487 6.44775 8.90626C6.42692 8.85765 6.4165 8.80557 6.4165 8.75001C6.4165 8.6389 6.4547 8.54168 6.53109 8.45834C6.60748 8.37501 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.37501 13.4686 8.45834C13.545 8.54168 13.5832 8.6389 13.5832 8.75001C13.5832 8.77779 13.5415 8.87501 13.4582 9.04168L10.4373 12.0625C10.3679 12.132 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.132 9.56234 12.0625Z"
                      fill="#1C1C1E"
                    />
                  </svg>
                )}
              </Button>
              {matricsToggle && (
                <div
                  className="custom-scrollbar py-2 flex w-full h-[84px] flex-col items-start rounded-[8px]"
                  style={{
                    position: "absolute",
                    top: 38,
                    right: 0,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 10px 4px rgba(28, 28, 30, 0.05)",
                    zIndex: 10000,
                    overflowY: "scroll",
                  }}
                  ref={metriceRef}
                >
                  <style>
                    {`
      .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
        height: 50px;
        
      }

      .custom-scrollbar::-webkit-scrollbar-track {
        background: white;
      }

      .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #F2F2F5;
        border-radius: 8px;
      }

    `}
                  </style>
                  {matricsArr.length > 0 &&
                    matricsArr.map((matrice: MatricsProps) => (
                      <div
                        className="flex h-[34px] p-2 items-center gap-1 self-stretch cursor-pointer"
                        key={matrice?.id}
                        onClick={(event) => {
                          event.stopPropagation();
                          setLocalConditions((prev) => {
                            const updatedConditions = [...prev];
                            updatedConditions[index] = {
                              ...updatedConditions[index],
                              metric: matrice?.backend_matrice_name,
                            };
                            return updatedConditions;
                          });
                          setMatricsToggle(false);
                        }}
                      >
                        <div
                          style={{
                            color: "#1C1C1E",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "18px",
                          }}
                        >
                          {matrice?.matrice_name}
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
            {cond?.metric_error && (<div className="flex items-center gap-1 self-stretch">
              <div className="flex w-4 h-4 p-[1.33px] justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <circle
                    cx="7.99967"
                    cy="7.99967"
                    r="6.66667"
                    stroke="#D10C00"
                    stroke-width="1.5"
                  />
                  <path
                    d="M7.99401 10H8"
                    stroke="#D10C00"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 8L8 5.33333"
                    stroke="#D10C00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                style={{
                  color: "var(--Text-Event-Red, #D10C00)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "18px",
                }}
              >
                Input cannot be empty
              </div>
            </div>)}
          </div>

          <div className="flex w-[33%] flex-col items-start gap-2 ">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              Parameters
            </div>
            <div className="relative w-full">
              <Button
                // color="neutral"
                sx={{
                  border: `1px solid #EAEAED`,
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  height: "38px",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "#FFF",
                  width: "100%",
                  ":hover": {
                    backgroundColor: "#FFF",
                  },
                }}
                onClick={() => setParametersToggle(!parametersToggle)}
                ref={parameterBtnRef}
              >
                <div
                  className=""
                  style={{
                    color: cond?.parameter ? "#1C1C1E" : "#97979A",
                    fontSize: "12px",
                    fontWeight: cond?.parameter ? "500" : "400",
                    lineHeight: "18px",
                  }}
                >
                  {cond?.parameter ? (cond?.parameter === "current" ? "Current Period" : cond?.parameter === "previous" ? "Comparison Period" : cond?.parameter === "difference" ? "Difference" : "Difference %") : "Select Parameters"}
                </div>
                {parametersToggle ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                      fill="#1C1C1E"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.56234 12.0625L6.5415 9.04168C6.49984 9.00001 6.46859 8.95487 6.44775 8.90626C6.42692 8.85765 6.4165 8.80557 6.4165 8.75001C6.4165 8.6389 6.4547 8.54168 6.53109 8.45834C6.60748 8.37501 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.37501 13.4686 8.45834C13.545 8.54168 13.5832 8.6389 13.5832 8.75001C13.5832 8.77779 13.5415 8.87501 13.4582 9.04168L10.4373 12.0625C10.3679 12.132 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.132 9.56234 12.0625Z"
                      fill="#1C1C1E"
                    />
                  </svg>
                )}
              </Button>
              {parametersToggle && (
                <div
                  className="custom-scrollbar py-2 flex w-full h-[84px] flex-col items-start rounded-[8px] "
                  style={{
                    position: "absolute",
                    top: 38,
                    right: 0,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 10px 4px rgba(28, 28, 30, 0.05)",
                    zIndex: 10,
                    overflowY: "scroll",
                  }}
                  ref={parameterRef}
                >
                  <style>
                    {`
      .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
        height: 50px;
        
      }

      .custom-scrollbar::-webkit-scrollbar-track {
        background: white;
      }

      .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #F2F2F5;
        border-radius: 8px;
      }

    `}
                  </style>
                  {parameterArr.length > 0 &&
                    parameterArr.map((parameter: ParametersProps) => (
                      <div
                        className="flex h-[34px] p-2 items-center gap-1 self-stretch cursor-pointer"
                        key={parameter?.id}
                        onClick={(event) => {
                          event.stopPropagation();
                          setLocalConditions((prev) => {
                            const updatedConditions = [...prev];
                            updatedConditions[index] = {
                              ...updatedConditions[index],
                              parameter: parameter?.parameter,
                            };
                            return updatedConditions;
                          });
                          setParametersToggle(false);
                        }}
                      >
                        <div
                          style={{
                            color: "#1C1C1E",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "18px",
                          }}
                        >
                          {parameter?.parameter === "current" ? "Current Period" : parameter?.parameter === "previous" ? "Comparison Period" : parameter?.parameter === "difference" ? "Difference" : "Difference %"}
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
            {cond?.parameter_error && (<div className="flex items-center gap-1 self-stretch">
              <div className="flex w-4 h-4 p-[1.33px] justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <circle
                    cx="7.99967"
                    cy="7.99967"
                    r="6.66667"
                    stroke="#D10C00"
                    stroke-width="1.5"
                  />
                  <path
                    d="M7.99401 10H8"
                    stroke="#D10C00"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 8L8 5.33333"
                    stroke="#D10C00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                style={{
                  color: "var(--Text-Event-Red, #D10C00)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "18px",
                }}
              >
                Input cannot be empty
              </div>
            </div>)}
          </div>

          <div className="flex w-[33%] flex-col items-start gap-2 ">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              Operations
            </div>
            <div className="relative w-full">
              <Button
                // color="neutral"
                sx={{
                  border: `1px solid #EAEAED`,
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  height: "38px",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "#FFF",
                  width: "100%",
                  ":hover": {
                    backgroundColor: "#FFF",
                  },
                }}
                onClick={() => setOperationsToggle(!operationsToggle)}
                ref={operationBtnRef}
              >
                <div
                  className=""
                  style={{
                    color: cond?.Operation ? "#1C1C1E" : "#97979A",
                    fontSize: "12px",
                    fontWeight: cond?.Operation ? "500" : "400",
                    lineHeight: "18px",
                  }}
                >
                  {cond?.Operation ? cond?.Operation : "Select Operations"}
                </div>
                {operationsToggle ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                      fill="#1C1C1E"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.56234 12.0625L6.5415 9.04168C6.49984 9.00001 6.46859 8.95487 6.44775 8.90626C6.42692 8.85765 6.4165 8.80557 6.4165 8.75001C6.4165 8.6389 6.4547 8.54168 6.53109 8.45834C6.60748 8.37501 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.37501 13.4686 8.45834C13.545 8.54168 13.5832 8.6389 13.5832 8.75001C13.5832 8.77779 13.5415 8.87501 13.4582 9.04168L10.4373 12.0625C10.3679 12.132 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.132 9.56234 12.0625Z"
                      fill="#1C1C1E"
                    />
                  </svg>
                )}
              </Button>
              {operationsToggle && (
                <div
                  className="custom-scrollbar py-2 flex w-full h-[84px] flex-col items-start rounded-[8px] "
                  style={{
                    position: "absolute",
                    top: 38,
                    right: 0,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 10px 4px rgba(28, 28, 30, 0.05)",
                    zIndex: 10,
                    overflowY: "scroll",
                  }}
                  ref={operationRef}
                >
                  <style>
                    {`
      .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
        height: 50px;
        
      }

      .custom-scrollbar::-webkit-scrollbar-track {
        background: white;
      }

      .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #F2F2F5;
        border-radius: 8px;
      }

    `}
                  </style>
                  {operationsArr.length > 0 &&
                    operationsArr.map((operation: OperationProps) => (
                      <div
                        className="flex h-[34px] p-2 items-center gap-1 self-stretch cursor-pointer"
                        key={operation?.id}
                        onClick={(event) => {
                          event.stopPropagation();
                          setLocalConditions((prev) => {
                            const updatedConditions = [...prev];
                            updatedConditions[index] = {
                              ...updatedConditions[index],
                              Operation: operation?.operation,
                            };
                            return updatedConditions;
                          });
                          setOperationsToggle(false);
                        }}
                      >
                        <div
                          style={{
                            color: "#1C1C1E",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "18px",
                          }}
                        >
                          {operation?.operation}
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
            {cond?.Operation_error && (<div className="flex items-center gap-1 self-stretch">
              <div className="flex w-4 h-4 p-[1.33px] justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <circle
                    cx="7.99967"
                    cy="7.99967"
                    r="6.66667"
                    stroke="#D10C00"
                    stroke-width="1.5"
                  />
                  <path
                    d="M7.99401 10H8"
                    stroke="#D10C00"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 8L8 5.33333"
                    stroke="#D10C00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                style={{
                  color: "var(--Text-Event-Red, #D10C00)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "18px",
                }}
              >
                Input cannot be empty
              </div>
            </div>)}
          </div>
        </div>

        <div className="flex items-start gap-4 w-full">
          <div className="flex w-[32%] flex-col items-start gap-2 ">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              Initial Value
            </div>
            <Input
              placeholder="Enter Value"
              sx={{
                "--Input-focusedThickness": "0px",
                width: "100%",
                height: "38px",
                paddingY: "8px",
                paddingX: "16px",
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "18px",
                backgroundColor: "#FFF",
                "&.Mui-disabled": {
                  backgroundColor: "#F3F3F7",
                },
                borderRadius: "4px",
              }}
              name="initial_value"
              value={cond?.initial_value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setLocalConditions((prev) => {
                  const updatedConditions = [...prev];
                  updatedConditions[index] = {
                    ...updatedConditions[index],
                    initial_value: e.target.value,
                  };
                  return updatedConditions;
                })
              }
            />
            {cond?.initial_value_error && (<div className="flex items-center gap-1 self-stretch">
              <div className="flex w-4 h-4 p-[1.33px] justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <circle
                    cx="7.99967"
                    cy="7.99967"
                    r="6.66667"
                    stroke="#D10C00"
                    stroke-width="1.5"
                  />
                  <path
                    d="M7.99401 10H8"
                    stroke="#D10C00"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 8L8 5.33333"
                    stroke="#D10C00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                style={{
                  color: "var(--Text-Event-Red, #D10C00)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "18px",
                }}
              >
                Input cannot be empty
              </div>
            </div>)}
          </div>

          <div className="flex w-[32%] flex-col items-start justify-start gap-2 ">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              Dependent Value
            </div>
            <Input
              placeholder="Enter Value"
              sx={{
                "--Input-focusedThickness": "0px",
                width: "100%",
                height: "38px",
                fontSize: "12px",
                paddingY: "8px",
                paddingX: "16px",
                fontWeight: "400",
                lineHeight: "18px",
                backgroundColor: "#FFF",
                "&.Mui-disabled": {
                  backgroundColor: "#F3F3F7",
                },
                borderRadius: "4px",
              }}
              name="dependent_value"
              value={cond?.dependent_value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setLocalConditions((prev) => {
                  const updatedConditions = [...prev];
                  updatedConditions[index] = {
                    ...updatedConditions[index],
                    dependent_value: e.target.value,
                  };
                  return updatedConditions;
                })
              }
              disabled={
                newconditionsArr[index]?.Operation !== "Between" && true
              }
            />
            {cond?.Operation === "Between" && cond?.dependent_value_error && (<div className="flex items-center gap-1 self-stretch">
              <div className="flex w-4 h-4 p-[1.33px] justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <circle
                    cx="7.99967"
                    cy="7.99967"
                    r="6.66667"
                    stroke="#D10C00"
                    stroke-width="1.5"
                  />
                  <path
                    d="M7.99401 10H8"
                    stroke="#D10C00"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 8L8 5.33333"
                    stroke="#D10C00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                style={{
                  color: "var(--Text-Event-Red, #D10C00)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "18px",
                }}
              >
                Input cannot be empty
              </div>
            </div>)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CondCmpForCreate;
